import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../redux/slices/Customer/customerReportSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./GroupLoanLetters.css";
import axios from "axios";

const GroupLoanPromise = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.userProfile);
    const superAdminId = Number(localStorage.getItem("userId")) || 0;

  const [loan, setLoan] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const [branch, setBranch] = useState(null);

  const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {

    const loadData = async () => {
      try {
        const loanRes = await axios.get(
          `https://payyug.in/api/group-loan/group/list`,
          {
            params: {
              superAdminId: profile.superAdminId || 14,
              officerId: profile.id,
              limit: 1000,
            },
          },
        );
        const loanList = loanRes.data?.data || loanRes.data || [];
        const selectedLoan = loanList.find((l) => String(l.id) === String(loanId));
        
        if (!selectedLoan) {
          toast.error("Loan not found");
          return;
        }
        setLoan(selectedLoan);

        if (profile?.superAdminId) {
          const customerAction = await dispatch(fetchCustomers({ 
            page: 1, limit: 1000, superAdminId: profile.superAdminId 
          }));
          
          const customerList = customerAction.payload?.data || customerAction.payload || [];
          const selectedCustomer = customerList.find(
            (c) => String(c.userId).toLowerCase() === String(selectedLoan?.member?.userId).toLowerCase()
          );
          setCustomer(selectedCustomer);

          const companyRes = await fetch(`https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`);
          const companyData = await companyRes.json();
          if (companyRes.ok) {
            const companyInfo = companyData.data || companyData;
            if (companyInfo.logo) {
              companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(/^images\//, "")}`;
            }
            setCompany(companyInfo);
          }

          if (profile.branchId) {
          try {
            const res = await fetch(`https://payyug.in/api/get-byId/${profile.branchId}`);
            if (!res.ok) throw new Error("Failed to fetch branch info");
            const branchData = await res.json();
            console.log("branch data: ",branchData)
            setBranch(branchData.data || branchData);
          } catch (err) {
            console.error("Failed to fetch branch details:", err);
          }
        }

          
        }
      } catch (err) {
        console.error(err);
      toast.error(err?.response?.data?.message||"Error loading data");
      }
    };

    if (profile) loadData();
  }, [dispatch, loanId, superAdminId, profile]);


  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Group Loan Promise`
        );

        const dataArray = res?.data?.data?.[0] || [];


        if (dataArray && dataArray.file) {
          const cleanSealPath = dataArray.file.replace(/^images\//, "");
          setBranchSealUrl(`https://payyug.in/${cleanSealPath}`);
        } else {
          setBranchSealUrl(null);
        }

        if (dataArray && dataArray.type) {
          const cleanSignPath = dataArray.type.replace(/^images\//, "");
          setBranchSignUrl(`https://payyug.in/${cleanSignPath}`);
        } else {
          setBranchSignUrl(null);
        }

      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  const handleDownloadPDF = async () => {
    const input = document.querySelector(".Sanc-letter-container");
    const button = document.querySelector(".loan-application-print-button");
    if (!input) return;

    if (button) button.style.display = "none";

    await new Promise((resolve) => {
      const images = input.querySelectorAll("img");
      let loaded = 0;
      if (images.length === 0) resolve();
      images.forEach((img) => {
        if (img.complete) {
          loaded++;
          if (loaded === images.length) resolve();
        } else {
          img.onload = img.onerror = () => {
            loaded++;
            if (loaded === images.length) resolve();
          };
        }
      });
    });

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4",true);
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`${customerData.fullName||loan?.memberName || loan?.member?.fullName}_GroupLoanPromise.pdf`);
    if (button) button.style.display = "block";
  };

  if (!loan) return <p>Loading...</p>;

 // ✅ Data Formatting
  const customerData = customer || {};
  const loanHolderName = customerData?.fullName||loan?.memberName || loan?.member?.fullName || "N/A";
  const guardianName = customerData.guardianName || loan?.member?.guardianName || null;
  const companyName = company?.name || "Company Name";

  const street = (customerData.address || loan?.member?.address || "N/A").replace(/\n/g, ", ");
  const country = customerData.country || loan?.member?.subDistrict || "";
  const district = customerData.district || loan?.member?.district || "N/A";
  const state = customerData.state || loan?.member?.state || "N/A";
  const pincode = customerData.pincode || loan?.member?.pincode || "N/A";
  const fullAddress = `${street},${district},${state}, ${country} - ${pincode}`;
  const placeAddress = branch
    ? `${branch.address}, ${branch.city}, ${branch.state} - ${branch.country || ""}`
    : "N/A";

  return (
    <div className="Sanc-letter-container">
      {/* Header */}
      <div className="Sancletter-header">
        <div className="Sanclogo-box">
          <img
            src={company?.logoUrl || "/logo.png"}
            alt="logo"
            crossOrigin="anonymous"
          />
        </div>

        <div className="Sanccompany-details Sanccompany-right-vertical">
          <div><h2>{companyName}</h2></div>
          <div><span><strong>CIN:</strong> {company?.cin || "N/A"}</span></div>
          <div><span><strong>Regt. Office:</strong> {company?.address || "N/A"}</span></div>
          <div><span><strong>Branch Name:</strong> {branch?.name || "N/A"}</span></div>
          <div><span><strong>Mobile No:</strong> {company?.contact || "N/A"}</span></div>
          <div><span><strong>Email ID:</strong> {company?.email || "N/A"}</span></div>
        </div>
      </div>

      <h3 className="title-center">DEMAND PROMISSORY NOTE</h3>
      <div className="date-place">
        <p><strong>Date:</strong> {loan.loanAppliedDate ? new Date(loan.loanAppliedDate).toLocaleDateString("en-GB") : "N/A"}</p>
        <p><strong>Place:</strong> {placeAddress}</p>
      </div>

      {/* Hindi Section */}
      <p>
        <strong>{companyName}</strong> मैं श्री / श्रीमती{" "}
        <strong>{loanHolderName}</strong>
       
       
        {guardianName ? ` C/O   ${guardianName}` : ""  } निवासी{" "}
        <strong>{fullAddress}</strong> का मूल निवासी हूँ,{" "}
        <strong>{companyName}</strong> द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की गई ऋण राशि रुपए ₹{" "}
        <strong>{loan.loanAmount || "N/A"}</strong> को मैं अपने ऋण चुकौती की अनुसूची के अनुसार
        ईएमआई किस्तों का भुगतना करने का वादा करता / करती हूं।
      </p>

      {/* English Section */}
      <p>
        This is to certify that I, <strong>{loanHolderName}</strong>
        {guardianName ? ` C/O ${guardianName}` : ""}, resident at{" "}
        <strong>{fullAddress}</strong> have taken a loan of amount{" "}
        <strong>Rs. {loan.loanAmount || "N/A"}</strong> from{" "}
        <strong>{companyName}</strong>. I hereby promise to pay the EMI instalments as per
        the schedule of my loan repayment that was previously checked and signed by me in the Loan Application Form.
      </p>

      <p>
        <strong>Amount: ₹ {loan.loanAmount || "N/A"}</strong>
      </p>

      {/* Stamp Box */}
      <div className="stamp-box-section">
        <div className="stamp-box">Affix ₹1 Revenue Stamp</div>
      </div>

      {/* Signature Table */}
      <table className="Promises-Signature-table">
        <tbody>
          <tr>
            <td>
              Member Signature <br /> (सदस्य के हस्ताक्षर)
              <div className="border-line"></div>
            </td>
            <td>
              Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
              <div className="border-line"></div>
            </td>
            <td>
              Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
              <div className="border-line"></div>
              <div className="footer-seal-sign box-size">
             {branchSealUrl && (
              <div className="footer-seal">
                <img src={branchSealUrl} alt="Seal" />
              </div>
            )}
            
            {branchSignUrl && (
              <div className="footer-sign">
                <img src={branchSignUrl} alt="Signature" />
              </div>
            )}
            </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="loan-application-print-button">
        <button onClick={handleDownloadPDF}>Download PDF</button>
      </div>
    </div>
  );
};


export default GroupLoanPromise
